'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _embed = require('@typeform/embed');

require('@typeform/embed/build/css/widget.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Widget = function Widget(_ref) {
  var id = _ref.id,
      style = _ref.style,
      options = _objectWithoutProperties(_ref, ['id', 'style']);

  var typeformElm = (0, _react.useRef)(null);

  (0, _react.useEffect)(function () {
    (0, _embed.createWidget)(id, _extends({ container: typeformElm.current }, options));
  }, [id]);

  return _react2.default.createElement('div', _extends({ className: 'react-typeform-embed', ref: typeformElm }, { style: style }));
};

exports.default = Widget;